import React from 'react';
import ExtendSessionHandler from 'smc-extendsession';
import { Message } from '@paypalcorp/worldready-react';
import { isLoggedIn } from '../../helpers/twHelper';

export const RE_LOGIN_URL = '/signin';
export const EXTEND_SESSION_URL = '/smarthelp/extendSession';

const SessionHandler = () => {
  const renderSessionHandler = () => {
    if (!isLoggedIn()) {
      return null;
    }
    return (
      <ExtendSessionHandler
        data-testid="sh-session-handler-extend-session-container"
        reLoginURL={RE_LOGIN_URL}
        extendSessionURL={EXTEND_SESSION_URL}
        warningMessage={<Message id="extendSession.extendSession.warningMessage" />}
        logoutMessage={<Message id="extendSession.extendSession.logoutMessage" />}
        extendSessionBtnTxt={<Message id="extendSession.extendSession.extendSessionBtnTxt" />}
      />
    );
  };

  return renderSessionHandler();
};

export default SessionHandler;
